module.exports = __webpack_public_path__ + "static/media/loc3_img32.601ed582.jpg";